import { useState } from 'react';

/**
 * @function useModal
 * @param { object } savingState
 * @param { object } savingHandler
 * @returns { object }
 */
function useModal(savingState, savingHandler) {
	const [open, setOpen] = useState(false);
	const [modal, setModal] = useState(false);

	const onToggle = () => {
		if (open) {
			const isUpdated = Object.values(savingState.isUpdated).includes(true);
			isUpdated ? setModal(true) : setOpen(false);
		} else {
			setOpen(true);
		}
	};

	const onSave = () => {
		savingHandler.onSave();
		savingHandler.onResetForUpdated();
		setOpen(false);
		setModal(false);
	};

	const onClose = () => {
		savingHandler.onReset();
		savingHandler.onResetForUpdated();
		setOpen(false);
		setModal(false);
	};

	return { open, modal, onToggle, onSave, onClose };
}

export default useModal;
